"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeGetShowImageTouchZoomHint = exports.getProductPreviewState = void 0;
const reselect_1 = require("reselect");
const getProductPreviewState = (state) => state.productPreview;
exports.getProductPreviewState = getProductPreviewState;
const makeGetShowImageTouchZoomHint = () => (0, reselect_1.createSelector)(exports.getProductPreviewState, (productPreviewState) => productPreviewState.imageTouchZoomHint);
exports.makeGetShowImageTouchZoomHint = makeGetShowImageTouchZoomHint;
